export const chartOptions = {
  chart: {
    toolbar: {
      show: false,
    },
  },
  dataLabels: {
    enabled: false,
  },
  colors: [""],
  yaxis: {
    show: false,
    reversed: true,
  },
  xaxis: {
    type: 'category',
    categories: [""],
    labels: {
      style: {
        colors: [""],
        fontSize: '14px',
      },
    },
  },
  grid: {
    padding: {
      right: 20,
      left: 45,
    },
  },
  tooltip: {
    theme: 'dark',
    x: {
      show: true,
      formatter: (val: number): string => `${val}`,
    },
  },
}

export default chartOptions
